import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

const DocumentManagemnetSystem = () => {
    debugger
    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
            <div className="container">
                <div className="row">
                    <h2>Document Management System</h2>
                </div>
                <hr />
                <div className="row">
                    <p>
                        Tejaxo Document Management System, a completely web browser based Document Management System Software Solution, is provided by Tejaxo Technologies Private Limited, an Indian Company based out of NCR, India.
                    </p>
                    <p>
                        Tejaxo - Document Management System (DMS), the award-winning document management software solution from Tejaxo Technologies, NCR, India. It is easy to install, easy to configure and easy to use system that allows you to spend more time on customer facing activities � instead of on tedious administrative and paper-based chores.
                    </p>
                    <p>
                        Our Document Management System (DMS) Software licensing, implementation and support packages are affordable for small, medium and large organizations alike. Tejaxo Document Management System (DMS) improves the way you Process and Manage your valuable documents, giving you peace of mind as you save time and money.
                    </p>
                    <p>
                        We offer Document Management System Software & related services to our customers in NCR, Pune, Ahmedabad, Baroda, Delhi, NCR, Bengaluru, Chennai, Hyderabad and Kolkata region. Our services are available with our partner network throughout India and across the globe.
                    </p>
                </div>
            </div>
            </section>
        </MasterPage>
    );
};

export default DocumentManagemnetSystem;
